import React from "react";
import classNames from "classnames/bind";
import styles from "./SizeLabel.module.scss";

const cx = classNames.bind(styles);

export type Props = {
  selectedSizeLabel?: string;
  sublabel?: string | null;
};

export const SizeLabel = ({ selectedSizeLabel, sublabel }: Props) => {
  if (selectedSizeLabel) {
    return (
      <h3 className={cx("selected")} data-testid="sizelist:label">
        <span className={cx({ selected: selectedSizeLabel })}>Size: </span>
        <span className={cx("selectedSize")}>{selectedSizeLabel}</span>
        {sublabel && <span className={cx("sublabel")}> {sublabel}</span>}
      </h3>
    );
  }

  return (
    <h3 className={cx("label")} data-testid="sizelist:label">
      Size
    </h3>
  );
};
